import { ReactComponent as CalendarLogo } from 'assets/img/icons/calendar.svg';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';
import { useState } from "react";
import DatePicker from 'react-datepicker';

import { Button, Col, Form, Row } from "react-bootstrap";

import { Loader } from "@launchmetrics/lm-ui";
import "react-datepicker/dist/react-datepicker.css";

function FormDatesSearch({ paginatedSearchLoading, onSubmit }) {
	const [range, setRangeState] = useState();
	const [rangeValid, setRangeValid] = useState(true);
	const [dates, setDates] = useState([dateSubtract(new Date(), 7, 'days'), new Date()]);

	const onChangeRange = (ev) => {
		const [value, units] = ev.target.value.split(" ");

		if (value !== "") {
			setRangeValid(true);
			setDates([
				dateSubtract(new Date(), value, units),
				new Date()
			]);
		}

		setRangeState(ev.target.value);
	}

	const setCustomDates = (dates) => {
		if (!dates[0] || !dates[1]) {
			return;
		}
		setRangeValid(dates[0].getTime() <= dates[1].getTime());
		setDates(dates);
		setRangeState('');
	};

	const onSubmitClick = (ev) => {
		ev.preventDefault();

		dates[0] = startOfDay(dates[0]);
		dates[1] = endOfDay(dates[1]);

		onSubmit({ beginDate: dates[0].toISOString(), endDate: dates[1].toISOString() });
	};

	const disableSubmit = paginatedSearchLoading || !rangeValid;
	const datePickerExtraClass = !rangeValid ? "is-invalid" : "";

	return (
		<Form>
			<Row className="align-items-center">
				<Col xs="auto">
					<CalendarLogo className="mr-1 mb-1" />
				</Col>
				<Col xs="auto">
					<Form.Control className="custom-select" as="select" onChange={onChangeRange} value={range}>
						<option value="7 days">Last week</option>
						<option value="1 months">Last month</option>
						<option value="3 months">Last 3 months</option>
						<option value="">Custom</option>
					</Form.Control>
				</Col>
				<Col xs="auto">
					<DatePicker
						className={"form-control " + datePickerExtraClass}
						dateFormat="dd/MM/yyyy"
						filterDate={excludeDates}
						popperPlacement="bottom-end"
						popperModifiers={{ flip: { enabled: false } }}
						selected={dates[0]} onChange={date => setCustomDates([date, dates[1]])} />
				</Col>
				<Col xs="auto">
					<DatePicker
						className={"form-control " + datePickerExtraClass}
						dateFormat="dd/MM/yyyy"
						filterDate={excludeDates}
						popperPlacement="bottom-end"
						popperModifiers={{ flip: { enabled: false } }}
						selected={dates[1]} onChange={date => setCustomDates([dates[0], date])} />
				</Col>
				<Col xs="auto">
					<Button
						type="submit"
						className="mr-1 mb-1"
						onClick={onSubmitClick}
						disabled={disableSubmit}
					>
						Submit
						{paginatedSearchLoading && <Loader styleProps={{ marginLeft: '10px'}}size={20} />}
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

function dateSubtract(date, value, unit) {
	if (unit === "days") {
		date.setDate(date.getDate() - value);
	} else if (unit === "months") {
		date.setMonth(date.getMonth() - value);
	} else {
		throw new Error(`Subtract ${unit} not supported`);
	}
	return date;
}

function excludeDates(date) {
	return new Date().getTime() > date.getTime();
}

export default FormDatesSearch;
